module.exports = __webpack_public_path__ + "static/media/Mining.e6e0b13d.m4v";